<template><div><h1>VUX V2.5.8 发布日志</h1>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 插件支持 setInputValue 方法 #1846</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] 修复 on-change 事件触发两次问题 #1847</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] popup显示时阻止背景滚动 #1830</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[fix] zIndex 值应该比 XDialog 大 #1820</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 新增 prop:show 控制是否显示</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.8 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.8-250.vue?88e3d2f2